/* eslint-disable react/prop-types */
import React from 'react';
import ToolIcon from '../../../../../../assets/icons/tool.svg';

const LineItemTag = ({ title }) => (
  <div className="allocation-card-line-item">
    <ToolIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle', marginRight: '4px', overflow: 'visible' }} /> {title}
  </div>
);

const LineItemsSection = ({ lineItems }) => {
  if (!lineItems) return null;

  return (
    <div className="allocation-card-line-items-container">
      {lineItems.map(({ title, type }) => {
        if (
          type !== 'c&d' &&
          type !== 'discount' &&
          title !== 'Collection & Delivery Bonus' &&
          title !== 'Repair & Service Bonus' &&
          title !== 'MOT Bonus'
        ) {
          return <LineItemTag key={title || type} title={title || type} />;
        }
        return null;
      })}
    </div>
  );
};

export default LineItemsSection;
